import type { HttpClient } from '~/api/client';
import { httpClient } from '~/api/client';
import type { OAISchema } from '~/types/openapi';

// Response 타입
type ShippingAddressResponse = OAISchema['MarketShippingAddressResponse'];

// Request 타입
type CreateRequest = OAISchema['CreateShippingAddressRequest'];
type UpdateRequest = OAISchema['UpdateShippingAddressRequest'];
type DeleteRequest = OAISchema['DeleteShippingAddressRequest'];
type UpdateDefaultRequest = OAISchema['UpdateDefaultShippingAddressRequest'];

export interface AddressDataSource {
  // Query
  getShippingAddresses(): Promise<ShippingAddressResponse[]>;
  getDefaultShippingAddress(): Promise<ShippingAddressResponse>;

  // Mutation
  createShippingAddress(data: CreateRequest): Promise<ShippingAddressResponse>;
  updateShippingAddress(data: UpdateRequest): Promise<ShippingAddressResponse>;
  deleteShippingAddress(data: DeleteRequest): Promise<void>;
  changeDefaultShippingAddress(data: UpdateDefaultRequest): Promise<void>;
}

export class AddressDataSourceImpl implements AddressDataSource {
  // eslint-disable-next-line no-useless-constructor
  constructor(private readonly client: HttpClient = httpClient) {}

  async getShippingAddresses() {
    return this.client.request<ShippingAddressResponse[]>({
      url: '/api/market-place/v1/shipping-address',
      method: 'get',
    });
  }

  async getDefaultShippingAddress() {
    return this.client.request<ShippingAddressResponse>({
      url: '/api/market-place/v1/shipping-address/default',
      method: 'get',
    });
  }

  async createShippingAddress(data: CreateRequest) {
    return this.client.request<ShippingAddressResponse>({
      url: '/api/market-place/v2/shipping-address',
      method: 'post',
      data,
    });
  }

  async updateShippingAddress(data: UpdateRequest) {
    return this.client.request<ShippingAddressResponse>({
      url: '/api/market-place/v1/shipping-address',
      method: 'put',
      data,
    });
  }

  async deleteShippingAddress(data: DeleteRequest) {
    await this.client.request<void>({
      url: '/api/market-place/v1/shipping-address',
      method: 'delete',
      data,
    });
  }

  async changeDefaultShippingAddress(data: UpdateDefaultRequest) {
    await this.client.request<void>({
      url: '/api/market-place/v1/shipping-address/default-change',
      method: 'patch',
      data,
    });
  }
}

export const addressDataSource = new AddressDataSourceImpl();
